import { BehaviorSubject, catchError, Observable, Subject, tap, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { AgGridPaginationConfig, PaginationBaseModel, TablePaginationModel, TablePaginationModelContact, TablePaginationModelVendorList, TableSouringPaginationModel } from "./ag-grid.model";
import { Result } from "../../model/response.model";
import { DataService } from "../../services/data.service";
import { SaveUserSetting} from './ag-grid.model';
import { StorageService } from "../../services/storage.service";
import { AgGridDataModelCompany, UserSetting } from "src/app/components/crm/crm.model";
import { CrmService } from "src/app/components/crm/crm.service";
import { ColumnApi } from "ag-grid-community";
import { AgGridDataModelInstock } from "src/app/components/parts-and-inventory/parts-list/pages/part-inventory/in-stock/instock.model";
import { AgGridDataModelPartsList } from "src/app/components/parts-and-inventory/parts-list/pages/parts-list/parts-list.model";
import { Router } from "@angular/router";
import { GridName } from "../../model/ag-grid-common-constant";
import { resolve } from "path";
import { rejects } from "assert";
@Injectable({
  providedIn: "root",
})
export class AgGridService {
  public starInfo: [{id:number, stars:number}] = [{id:0, stars:0}];
  public agGridPaginationConfigRes = new BehaviorSubject(undefined);
  public gridColumnApi = new BehaviorSubject(undefined);
  public gridApi = new BehaviorSubject(undefined);
  public agGridPaginationConfig = new AgGridPaginationConfig();
  onColumnDragStopped = new BehaviorSubject(undefined);
  ratingChanged = new BehaviorSubject(undefined);
  userSetting = new UserSetting();
  // public servic=new BehaviorSubject<boolean>(false)
  tablePaginationData = new BehaviorSubject<TablePaginationModel>(undefined);
  tablePaginationContactData = new BehaviorSubject<TablePaginationModelContact>(undefined);
  totalPages = false;
  selectionChanged = new Subject();
  indexToSkip = 2
  toggleHeaderExpandIcon = new BehaviorSubject(undefined);
  importCompaniesValue = new BehaviorSubject(undefined);
  userList = new BehaviorSubject(undefined);
  unChecked = new BehaviorSubject(undefined);
  public dataInput = new BehaviorSubject(undefined);
  toggleHeaderCheckedValue = new BehaviorSubject<any>(null);
  commentId = 0;
  toggleCheckboxIcon = new BehaviorSubject<any>(null);
 static url: any;

  constructor(private service: DataService, private crmService: CrmService,
    public storageService:StorageService,
   public route: Router,) {
            AgGridService.url = this.route.url;

    }
    private tablePagination = new BehaviorSubject<any>(undefined);


    setPaginationData(data: any): void {
      this.tablePagination.next(data);
    }
  
  
    getPaginationData(): Observable<any> {
      return this.tablePagination.asObservable();
    }
  
  getGridApi() {
    return this.gridApi.getValue();
  }

  setGridApi(gridApi) {
    this.gridApi.next(gridApi);
  }

  getGridColumnApi() {
    return this.gridColumnApi.getValue();
  }

  setGridColumnApi(gridColumnApi) {
    this.gridColumnApi.next(gridColumnApi);
  }

  public onPageChanged(pageNum: number) {
    this.agGridPaginationConfig.currentPageNumber = pageNum;
    this.agGridPaginationConfig.tableOffset = pageNum - 1;
  }

  public onPageSizeChanged(pageSize: number) {
    this.agGridPaginationConfig.pageSize = pageSize;
    this.onPageChanged(1);
  }

  public onSort(pageNum: number) {
    this.onPageChanged(1);
  }

  public updateTableData(res: any): any {
    this.agGridPaginationConfigRes.next(undefined);
   // this.agGridPaginationConfig.rows = res?.response;
    this.agGridPaginationConfig.rows = res?.response ? res.response : [];
    this.agGridPaginationConfig.totalRecords = res?.totalRecords;
    return this.agGridPaginationConfig;
  }
  private columnState: any;

  saveColumnState(columnApi: ColumnApi) {
    this.columnState = columnApi.getColumnState();
  }

  restoreColumnState(columnApi: ColumnApi) {
    if (this.columnState) {
      columnApi.setColumnState(this.columnState);
    }
  }

  // GetAllAccountTypes dropdown list
  accountTypeSelectDropdown(): Observable<Result> {
    let url = "app/DropDown/getAllSalesStageList";
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }
  GetAllArchivedCompanies(getAllCompanyArchiveList: TablePaginationModel): Observable<Result> {
    let url = "app/Company/getAllCompanyArchiveList";
    return this.service.getWithParams(url, getAllCompanyArchiveList).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }


  // get All Crm Data
  GetAllCRM(getAllCrmData: TablePaginationModel): Observable<Result> {
    let url = "app/Company/getAllCompanyWithFilter";
    return this.service.post(url, getAllCrmData).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  GetAllContactsRecybinData(getAllContactsData: TablePaginationModel): Observable<Result> {
    let url = "app/CompanyContact/getAllContactRecycleBin";
    return this.service.post(url, getAllContactsData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  GetAllCompanyRecybinData(getAllContactsData: TablePaginationModel): Observable<Result> {
    let url = "app/Company/getAllCompanyRecycleBin";
    return this.service.post(url, getAllContactsData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  GetAllRequirementData(getAllRequirementData: any): Observable<Result> {
    let url = "app/Requirement/getAllRequirements";
    return this.service.getWithParams(url, getAllRequirementData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  // get All Contacts Data in Crm
  GetAllContacts(getAllContactsData: TablePaginationModel): Observable<Result> {
   // let url = "SourceMatrixApi/People/GetAllPersonalInfos";
    let url = "app/CompanyContact/getAllCompanyContactWithFilter";
    return this.service.post(url, getAllContactsData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  GetAllVendorContacts(getAllContactsData: TablePaginationModelContact): Observable<Result> {
   // let url = "SourceMatrixApi/People/GetAllPersonalInfos";
    let url = "app/VendorContact/getAllVendorContactWithFilter";
    return this.service.post(url, getAllContactsData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }


  saveUserSetting( saveUserSetting:SaveUserSetting): Observable<Result> {
    saveUserSetting.userId=this.storageService.retrieve('userId')
    let url = "identity/Users/saveUserSetting";
    return this.service.post(url, saveUserSetting).pipe<Result>(tap((response: any) => {
    return response;
      })
    );
  }

  //get all code-crosswalk data
  getAllCodeCrosswalk(getAllCodeCrosswalkData: PaginationBaseModel): Observable<Result> {
    let url = "app/masterCodeCrosswalk/getAllCodeCrosswalk";
    return this.service.post(url, getAllCodeCrosswalkData).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getVendorList(getVendorList: TablePaginationModel): Observable<Result> {
    let url = "app/Vendor/getAllVendorWithFilter";
    return this.service.post(url, getVendorList).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllSourcingData(data: TableSouringPaginationModel): Observable<Result> {
    let url = "app/sourcing/getAllSourcing";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }
  //Grid Coldef
  getAllsavedcolumnDefinitions(name: any): Observable<Result> {
    let url = `identity/users/getColDefination?gridName=${name}`;
    return this.service.get(url, true).pipe<Result>(tap((response: any) => {
      return response;
    }))
  }

  // Save column definition to backend when user reorders columns
  saveColumnDefinition(payload: any): Observable<Result> {
    let url = "identity/users/saveColDefination";
    return this.service.post(url, payload).pipe<Result>(tap((response: any) => {
      return response;
    })
    );
  }

  handleError(err: any): any {
    throw new Error("Something went wrong.");
  }

  public stage = new BehaviorSubject("All");
  getStage() {
    return this.stage.getValue();
  }

  setStage(stage) {
    this.stage.next(stage);
  }

  public filter = new BehaviorSubject("");

  getFilter(){
    return this.filter.getValue()
  }
  setFilter(filter){
    this.filter.next(filter)
  }
  dragColumn(page:string){
    if(page == 'contacts'){
      this.indexToSkip = 1
    }else{
      this.indexToSkip = 2
    }
    // this.userSetting=this.storageService?.retrieve("userSetting");
    this.crmService.getUserSetting()
    .subscribe(res => {
      if (res?.isSuccess) {
        // let json = JSON.parse(res?.response?.userSetting) ?? {}
        let json = JSON.parse(res?.response) ?? {}

        setTimeout(() => {
         json?.[page]?.map(value => {
           // this.getGridColumnApi().moveColumn(value.name, value.index+this.indexToSkip);
          })
        }, 20);
      }
    })
  }

}
